import { Stack, Typography } from '@mui/joy';
import { PencilSimpleLine, TrashSimple } from '@phosphor-icons/react';

import { useAgGridTableContext } from 'core/states';
import {
  RemovePricingProfileCostingCalculationsButton,
  UpsertPricingProfileCostingCalculationButton,
} from 'pricing/components';
import { IPricingProfile, IPricingProfileCostingCalculation } from 'pricing/types';
import { Color, Direction, Level } from 'theme/enums';

interface IProps {
  pricingProfile: IPricingProfile;
  data: IPricingProfileCostingCalculation;
  isEditable?: boolean;
}

export const ActionsCell = ({ data, isEditable = true, pricingProfile }: IProps) => {
  const { gridApi } = useAgGridTableContext();

  const refreshTable = () => {
    gridApi?.refreshServerSide();
  };

  return (
    <Stack direction={Direction.ROW} gap={1}>
      <UpsertPricingProfileCostingCalculationButton
        pricingProfile={pricingProfile}
        costingCalculation={data}
        buttonElement={
          <Typography
            color={isEditable ? Color.PRIMARY : Color.NEUTRAL}
            level={Level.BODY_SM}
            sx={{ cursor: isEditable ? 'pointer' : 'not-allowed', opacity: isEditable ? 1 : 0.5 }}
          >
            <PencilSimpleLine />
          </Typography>
        }
        onSubmitSuccess={refreshTable}
        onRemoveSuccess={refreshTable}
        disabled={!isEditable}
      />

      <RemovePricingProfileCostingCalculationsButton
        pricingProfileCostingCalculations={[data]}
        buttonElement={
          <Typography
            color={isEditable ? Color.DANGER : Color.NEUTRAL}
            level={Level.BODY_SM}
            sx={{ cursor: isEditable ? 'pointer' : 'not-allowed', opacity: isEditable ? 1 : 0.5 }}
          >
            <TrashSimple />
          </Typography>
        }
        onRemoveSuccess={refreshTable}
        disabled={!isEditable}
      />
    </Stack>
  );
};
